module.exports = __webpack_public_path__ + "img/16_003.20e63e02.webp";